module.exports = __webpack_public_path__ + "static/media/state-planet-13.d6894401.png";